import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const RatingContent = ({ rating }) => (
  <div className="cm-rating">
    <div className="cm-rating-head">
      <span className="cm-rating-ticker">{rating.ticker}</span>
      <span className={`cm-rating-conviction cm-rating-conviction--${rating.conviction.toLowerCase().replace(" ", "-")}`}>
        {rating.conviction}
      </span>
    </div>
    <p className="cm-rating-reasoning">{rating.conviction_reasoning}</p>
  </div>
);

const ChatMessage = ({ role, type, content }) => {
  const isUser = role === "user";

  return (
    <div className={`cm-row ${isUser ? "cm-row--user" : "cm-row--assistant"}`}>
      <style>{`
        .cm-row { display: flex; width: 100%; margin-bottom: var(--space-6); }
        .cm-row--user { justify-content: flex-end; }
        .cm-row--assistant { justify-content: stretch; }

        .cm-bubble-user {
          background: var(--surface-2);
          border: 1px solid var(--border-subtle);
          border-radius: var(--radius-lg);
          padding: var(--space-3) var(--space-4);
          max-width: 70%;
          font-size: 15px;
          line-height: 1.6;
          color: var(--text-primary);
          white-space: pre-wrap;
          word-break: break-word;
        }

        .cm-assistant {
          width: 100%;
          font-size: 15px;
          line-height: 1.75;
          color: var(--text-primary);
        }

        .cm-assistant.cm-assistant--error {
          color: var(--negative);
        }

        .cm-assistant p { margin: 0 0 var(--space-4); }
        .cm-assistant p:last-child { margin-bottom: 0; }
        .cm-assistant h1, .cm-assistant h2, .cm-assistant h3 {
          font-family: var(--font-display);
          font-weight: 500;
          color: var(--text-primary);
          margin: var(--space-6) 0 var(--space-3);
          line-height: 1.3;
        }
        .cm-assistant h1:first-child, .cm-assistant h2:first-child, .cm-assistant h3:first-child { margin-top: 0; }
        .cm-assistant ul, .cm-assistant ol { margin: 0 0 var(--space-4); padding-left: 1.4em; }
        .cm-assistant li { margin-bottom: var(--space-1); }
        .cm-assistant strong { color: var(--text-primary); font-weight: 700; }
        .cm-assistant code {
          font-family: var(--font-mono);
          font-size: 0.9em;
          background: var(--surface-2);
          border: 1px solid var(--border-subtle);
          border-radius: 4px;
          padding: 1px 6px;
        }
        .cm-assistant pre {
          background: var(--surface-1);
          border: 1px solid var(--border-subtle);
          border-radius: var(--radius-md);
          padding: var(--space-4);
          overflow-x: auto;
          margin: 0 0 var(--space-4);
        }
        .cm-assistant pre code { background: none; border: none; padding: 0; }
        .cm-assistant table { border-collapse: collapse; width: 100%; margin: 0 0 var(--space-4); font-size: 14px; }
        .cm-assistant th, .cm-assistant td { border: 1px solid var(--border-subtle); padding: var(--space-2) var(--space-3); text-align: left; }
        .cm-assistant th { color: var(--text-secondary); font-weight: 600; background: var(--surface-1); }
        .cm-assistant blockquote {
          border-left: 2px solid var(--accent-border);
          margin: 0 0 var(--space-4);
          padding-left: var(--space-4);
          color: var(--text-secondary);
        }
        .cm-assistant a { color: var(--accent); }

        .cm-rating { border: 1px solid var(--border-subtle); border-radius: var(--radius-md); padding: var(--space-4); background: var(--surface-1); }
        .cm-rating-head { display: flex; align-items: center; gap: var(--space-3); margin-bottom: var(--space-3); }
        .cm-rating-ticker { font-family: var(--font-mono); font-weight: 700; font-size: 15px; letter-spacing: 0.04em; }
        .cm-rating-conviction { font-size: 12px; font-weight: 600; padding: 3px 10px; border-radius: var(--radius-pill); text-transform: uppercase; letter-spacing: 0.04em; }
        .cm-rating-conviction--strong-buy, .cm-rating-conviction--buy { background: var(--positive-soft); color: var(--positive); }
        .cm-rating-conviction--hold { background: var(--neutral-soft); color: var(--neutral); }
        .cm-rating-conviction--avoid { background: var(--negative-soft); color: var(--negative); }
        .cm-rating-reasoning { font-size: 14px; line-height: 1.7; color: var(--text-secondary); }
      `}</style>

      {isUser ? (
        <div className="cm-bubble-user">{content}</div>
      ) : (
        <div className={`cm-assistant${type === "error" ? " cm-assistant--error" : ""}`}>
          {type === "rating" ? (
            <RatingContent rating={content} />
          ) : (
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
          )}
        </div>
      )}
    </div>
  );
};

export default ChatMessage;
